import { Modal } from "antd";
import { useEffect, useState } from "react";
import session_time from "../../assets/icons/session_time.png";
import time from "../../assets/icons/time.png";

const SessionError = ({ open, cb }) => {
  const [modal, setModal] = useState(false);

  useEffect(() => {
    setModal(open);
  }, [open]);

  return (
    <Modal
      visible={modal}
      title={
        <div className="flex-title">
          <img src={time} width={18} /> Active Session Warning
        </div>
      }
      onCancel={() => {
        setModal(false);
      }}
      footer={[]}
      maskClosable={false} // Prevent closing on outside click
      keyboard={false}
    >
      <div className="session-timeout">
        <div className="content">
          <div>
            <label>A session is already active for this account.</label>
            <span>
              You may need to log out of the current session to continue.
            </span>
          </div>
          <div>
            <img src={session_time} />
          </div>
        </div>
        <div className="action-btns mt1">
          <button className="more" onClick={cb}>
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default SessionError;
